<script>
export default {
  name: "formatterAutoMV",
  props: {
    row: {
      type: Object,
      default: () => {}
    }
  },
  functional: true,

  render(createElement, context) {
    // let { rowValue } = context.data.attrs;
    let { column } = context.data.attrs;
    let { row } = context.props;
    //console.log("context: ", context)

    let Type = String;
    let Status = String;
    let customStyle = String;
    if (
      Object.prototype.hasOwnProperty.call(row, "PercentageProsposal") &&
      column === "PercentageProsposal"
    ) {
      if (row.PercentageProsposal == 75) {
        Type = "Azul";
        Status = row.PercentageProsposal;
        customStyle =
          "color: blue; font-weight:bold; text-align:center; background-color:rgba(29, 255, 255, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.PercentageProsposal == 100) {
        Type = "Verde";
        Status = row.PercentageProsposal;
        customStyle =
          "color: green; font-weight:bold; text-align:center; background-color:rgba(87, 255, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.PercentageProsposal == 50) {
        Type = "Negro";
        Status = row.PercentageProsposal;
        customStyle =
          "color: black; font-weight:bold; text-align:center; background-color:rgba(504, 95, 52, 0.2); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else {
        Type = "Rojo";
        Status = row.PercentageProsposal;
        customStyle =
          "color: red; font-weight:bold; text-align:center; background-color:rgba(255, 29, 29, 0.1); border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "TypeStrategic") &&
      column === "TypeStrategic"
    ) {
      if (row.TypeStrategic == 1) {
        Type = "Operacional";
        Status = "Operacional";
        customStyle =
          "color:#987c06; background-color:rgba(252, 234, 8, 0.2 ); font-weight: bold; text-align:center;  border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else {
        Type = "Estrátegico";
        Status = "Estrátegico";
        customStyle =
          "color: rgba(246, 97, 228); background-color:rgba(246, 97, 228, 0.2); font-weight:bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "PerpectiveID") &&
      column === "PerpectiveID"
    ) {
      if (row.PerpectiveID == 1) {
        Type = "Financiera";
        Status = "Financiera";
        customStyle =
          "color:blue; background-color:rgba(168, 211, 240, 0.6); font-weight: bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.PercentageProsposal == 50) {
        Type = "Del cliente";
        Status = "Del cliente";
        customStyle =
          "color: green; background-color:rgba(195, 240, 168, 0.6); font-weight:bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else if (row.PercentageProsposal == 50) {
        Type = "Procesos inter";
        Status = "Procesos inter";
        customStyle =
          "color: yellow; background-color:rgba(240, 234, 168, 0.6); font-weight:bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else {
        Type = "Des y Aprendi";
        Status = "Des y Aprendi";
        customStyle =
          "color: violet; background-color:rgba(220, 168, 240, 0.6); font-weight:bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "Status") &&
      column === "Status"
    ) {
      if (
        row.Status == "Abierta a tiempo" ||
        row.Status == "Cerrada a tiempo"
      ) {
        Type = row.Status;
        Status = row.Status;
        customStyle =
          "color:green; background-color:rgba(87, 255, 29, 0.1); font-weight: bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else {
        Type = row.Status;
        Status = row.Status;
        customStyle =
          "color: red; background-color:rgba(255, 29, 29, 0.1); font-weight:bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    } else if (
      Object.prototype.hasOwnProperty.call(row, "Ranting") &&
      column === "Ranting"
    ) {
      if (row.Ranting == null) {
        Type = row.Ranting;
        Status = "Sin Calificar";
        customStyle =
          "color: red; background-color:rgba(255, 29, 29, 0.1); font-weight:bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      } else {
        Type = row.Ranting;
        Status = "Calificado";
        customStyle =
          "color: green; background-color:rgba(87, 255, 29, 0.1); font-weight: bold; text-align:center; border-radius: 5%; padding-left: 25px; padding-right: 25px; padding-bottom: 5px; padding-top: 5px;";
      }
      return createElement(
        "div",
        {
          attrs: {
            name: "",
            class: Type,
            style: customStyle,
            effect: "dark"
          }
        },
        Status
      );
    }
    return createElement();
  }
};
</script>
<style scoped>
.Azul {
  color: blue;
}
.Verde {
  color: green;
}
.amarillo {
  background-color: #f5e10c;
}
.Naranja {
  color: orange;
}
.Rojo {
  color: rgba(255, 0, 0, 0.712);
}
.Negro {
  color: #606266;
}
</style>
